<template>
  <!-- Uma raiz, e só quando há o que mostrar: quem usa passa espaçamento (`class`), e ele precisa
       de onde cair -->
  <div v-if="failures.length">
    <!-- align-baseline, e não center: a frase que quebra deixava o ⚠ no meio das duas linhas, e não
         na primeira -->
    <div v-for="(failure, index) in failures" :key="index" class="d-flex align-baseline mt-1 text-caption text-warning">
      <v-icon size="x-small" class="mr-1">mdi-alert-outline</v-icon>{{ text(failure) }}
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, toNative} from 'vue-facing-decorator'
import {FieldFailure} from '@/utils/fieldValidation'
import {failureText} from '@/utils/saveErrors'

/**
 * O que o item, como está GRAVADO, viola num campo: a regra nova, o obrigatório que ficou vazio, o
 * valor único que se repete — das falhas que a leitura trouxe (`meta: failures`; ver `failuresAt`).
 * Aviso, e não erro: ninguém é barrado por ele — a catraca decide o que se cobra ao salvar. A frase
 * é a do formulário.
 *
 * Um componente porque são três lugares: embaixo de um campo da ficha (`InstanceFields`), embaixo do
 * cabeçalho da seção de um relacionamento múltiplo, que não é campo, e embaixo do campo que o formulário de
 * edição ainda não mexeu (`InstancePropertyInput`) — o mesmo símbolo e a mesma cor nos três.
 */
@Component({name: 'ontos-field-failures'})
class FieldFailures extends Vue {
  @Prop({type: Array, default: () => []}) readonly failures!: FieldFailure[]

  text(failure: FieldFailure): string {
    return failureText(failure)
  }
}

export default toNative(FieldFailures)
</script>
